<template>
  <b-modal title="Lista de Templates" v-model="show" size="lg">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE TEMPLATES :::::::::::::::::::::::::::: -->
      <b-table
        id="table-inspecao-temp"
        bordered
        hover
        small
        head-variant="light"
        :items="getFilterInspecoes(filtro)"
        :fields="fields.inspecaoTemplate"
      >
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="load(data.item)">
              <b-icon icon="file-earmark-arrow-down" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <template #modal-footer>
      <b-form inline>
        <b-icon icon="search" variant="primary" scale="1.2" class="m-1" />
        <b-form-input
          id="insp-filter-tmp"
          type="search"
          size="sm"
          variant="warning"
          class="m-1 p-1"
          placeholder="Descrição"
          v-model="filtro"
        />
      </b-form>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useTemplateStore } from "@/stores/TemplateStore";
import TableFields from "@/tools/TableFields";

export default {
  name: "InspecaoTemplateModal",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      template: { id: 0, descricao: "", observacao: "", itens: [] },
      filtro: "",
    };
  },

  methods: {
    load(dados) {
      this.template.id = dados.id;
      this.template.descricao = dados.descricao;
      this.template.observacao = dados.observacao;
      this.templateStore.LISTAR_ITENS_INSPECAO(dados.id).then(() => {
        this.template.itens = this.getInspecaoItens;
        this.$emit("loadTemplate", this.template);
        this.show = !this.show;
      });
    },

    call() {
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const templateStore = useTemplateStore();
    const { getInspecaoItens } = storeToRefs(templateStore);
    const { getFilterInspecoes } = storeToRefs(templateStore);

    return {
      store,
      templateStore,
      getInspecaoItens,
      getFilterInspecoes,
    };
  },
};
</script>

<style lang="scss" scoped>
#insp-filter-tmp {
  width: 22rem;
}
</style>
